(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["quote-carousel-with-logos-product"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  // Main quote carousel
  $('.main-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    // autoplay: true,
    // autoplaySpeed: 3000,
    asNavFor: '.thumb-slider',
    // adaptiveHeight: true
  });

  $('.thumb-slider').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.main-slider',
    dots: false,
    centerMode: true,
    focusOnSelect: true,
    arrows: true,
    prevArrow: `<button type="button" class="slick-prev custom-arrow">
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 25.3398C7.78679 25.3398 2.75 20.303 2.75 14.0898C2.75 7.87664 7.78679 2.83984 14 2.83984C20.2132 2.83984 25.25 7.87664 25.25 14.0898C25.25 20.303 20.2132 25.3398 14 25.3398Z" stroke="#FBF8F4" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M18.5 14.0898H9.5" stroke="#FBF8F4" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14 18.5898L9.5 14.0898L14 9.58984" stroke="#FBF8F4" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>`,
    nextArrow: `<button type="button" class="slick-next custom-arrow">
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 25.3398C20.2132 25.3398 25.25 20.303 25.25 14.0898C25.25 7.87664 20.2132 2.83984 14 2.83984C7.7868 2.83984 2.75 7.87664 2.75 14.0898C2.75 20.303 7.7868 25.3398 14 25.3398Z" stroke="#FBF8F4" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9.5 14.0898H18.5" stroke="#FBF8F4" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14 18.5898L18.5 14.0898L14 9.58984" stroke="#FBF8F4" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>`,
    variableWidth: false,
    responsive: [
      {
        breakpoint: 990, // up to 990px
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767, // up to 767px
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: '0px',
          dots: true,
        }
      }
    ]
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-carousel-with-logos"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const thumbSwiper = new Swiper('.thumb-slider', {
    spaceBetween: 10,
    slidesPerView: 4,
    watchSlidesProgress: true,
  });

  const mainSwiper = new Swiper('.main-slider', {
    spaceBetween: 10,
    slidesPerView: 1,
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true // smooth transition between slides
    }, // fade transition
    autoplay: {
      delay: 3000, // time in ms between slides
      disableOnInteraction: false,
    },
    thumbs: {
      swiper: thumbSwiper
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
